<template>
    <iframe align="middle" frameborder="0" ref="prijava" scrolling="no" src="https://survey.alchemer.eu/s3/90436937/IzziRokus-blog-prijava-na-novice"></iframe>
</template>


<script>

    export default {
		data() {
			return {
				status: undefined
			}
		},
        mounted() {
            this.bindIframe();
        },
        destroyed() {
            this.unbindIframe();
        },
        methods: {
            bindIframe() {
                window.addEventListener('message', this.handleIframeMessage);
            },
            unbindIframe() {
                window.removeEventListener('message', this.handleIframeMessage);
            },
            handleIframeMessage(event) {
                if (event.origin.indexOf('https://survey.alchemer.eu') > -1) {
                    if (!this.$refs.prijava) return;
                    if (!event.data || !event.data.type) return;

                    // set css for iframe in parent scss
                    if (event.data.type === "css" ) {
                        setTimeout(() => {
                            this.$refs.prijava.classList.add(event.data['value']);
                        }, 1000);
                    // set calculated height of iframe
                    } else if (event.data.type === "height") {
                        this.$refs.prijava.style.height = event.data['value'] + 'px';
                    }
                }
            },
			setResult(status) {
                this.status = status;
			}
        }
    }
</script>
